// ==========================================================
// Indent Type Enum
// Must match DB ENUM exactly
// ==========================================================

const INDENT_TYPE = {
  PRODUCTION: "PRODUCTION",
  MAINTENANCE: "MAINTENANCE",
  GENERAL: "GENERAL",
};

export default INDENT_TYPE;
